import { Reducer } from '@reduxjs/toolkit'

import {
  ActionTypes,
  GET_USER_PERMISSIONS,
  GET_USER_PERMISSIONS_FAILURE,
  GET_USER_PERMISSIONS_SUCCESS,
  UPDATE_PERMISSIONS,
  UPDATE_PERMISSIONS_FAILURE,
} from './ActionTypes'
import { IUserPermissionState } from './IUserPermissionState'

const initialState: IUserPermissionState = {
  userPermissions: [],
  isLoading: false,
  error: false,
}

export const permissionReducer: Reducer<IUserPermissionState, ActionTypes> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case GET_USER_PERMISSIONS:
      return {
        ...state,
        isLoading: true,
      }
    case GET_USER_PERMISSIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
        userPermissions: action.payload.userPermissions,
      }
    case GET_USER_PERMISSIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
      }
    case UPDATE_PERMISSIONS:
      const newPermissions = [...state.userPermissions]

      for (let i = 0; i < action.payload.permissions.length; i++) {
        const newPermission = action.payload.permissions[i]

        const permissionIndex = newPermissions.findIndex(
          userPermission =>
            userPermission.userId === newPermission.userId &&
            userPermission.name === newPermission.name,
        )

        if (-1 === permissionIndex) {
          continue
        }

        newPermissions[permissionIndex] = newPermission
      }

      return {
        ...state,
        userPermissions: newPermissions,
      }
    case UPDATE_PERMISSIONS_FAILURE:
      return {
        ...state,
        error: true,
      }
    default:
      return state
  }
}
